/**
 * Validation helper cho General Info (thông tin dự án và người đánh giá)
 * Sử dụng cho tất cả các form review
 */

/**
 * Validate thông tin cơ bản của người đánh giá (cho tất cả các forms)
 * @param {Object} reviewerInfo - Thông tin người đánh giá
 * @param {Function} t - Translation function
 * @returns {string|null} - Error message hoặc null nếu valid
 */
export const validateReviewerBasicInfo = (reviewerInfo, t) => {
  // Kiểm tra họ tên
  if (!reviewerInfo?.fullname) {
    return t('council.review.reviewerNameRequired');
  }

  return null;
};

/**
 * Validate đầy đủ general info cho Financial Review
 * Bao gồm cả thông tin thanh toán
 * @param {Object} _generalInfo - Thông tin dự án
 * @param {Object} _reviewerInfo - Thông tin người đánh giá
 * @param {Function} _t - Translation function
 * @returns {string|null} - Error message hoặc null nếu valid
 */
// eslint-disable-next-line no-unused-vars
export const validateGeneralInfoWithPayment = (_generalInfo, _reviewerInfo, _t) => null;
